module.exports = __webpack_public_path__ + "media/components/UI/TrboUploader/iconExtensions/csv-d770d790ad7e3b0e611eae338c4811ef.svg";